@if (erRedigerPause()) {
  <pause-rediger [id]="pause().id" [sakstidspunkter]="sakstidspunkterBeregning()!" (vedLukk)="redigerPauseFerdig()"/>

} @else {
  <div class="tittel-og-detaljer-kontainer">
    <div class="tittel-linje" toggleKlasseVedSticky>
      <span class="tittel" data-testid="sakstittel">{{ pause().tittel }}</span>
      <span class="handlinger">
        @if (redigeringMulig()) {
          <button mat-icon-button
                  (click)="redigerPause()"
                  [disabled]="menyDeaktivert()"
                  class="rediger-knapp"
                  matTooltip="{{ 'Rediger pause' | translate }}"
                  matTooltipPosition="below"
                  data-testid="rediger-sak-knapp">
            <mat-icon>edit</mat-icon>
          </button>
        }
        <button mat-icon-button
                [matMenuTriggerFor]="pauseMeny"
                (click)="$event.stopPropagation()"
                [disabled]="menyDeaktivert()"
                class="meny-trigger"
                aria-label="Meny"
                data-testid="saksmeny-knapp">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #pauseMeny="matMenu" aria-label="{{'Pausesakmeny'|translate}}">
          @if (redigeringMulig()) {
            <button mat-menu-item (click)="flyttPause()">
              <mat-icon>move_down</mat-icon>
              {{ 'Flytt' | translate }}
            </button>
          }
          @if (kopierMulig()) {
            <button mat-menu-item (click)="kopierPause()">
              <mat-icon>content_copy</mat-icon>
              {{ 'Kopier' | translate }}
            </button>
          }
          @if (redigeringMulig()) {
            <button mat-menu-item (klikk)="slettPause()" [bekreftKlikk]="'Ja, slett pausen' | translate" data-testid="slett">
              <mat-icon fontSet="ion-ios-trash" class="mat-icon--ionic-ikon"/>
              {{ 'Slett'|translate }}
            </button>
          }
        </mat-menu>
      </span>
    </div>

    <tittel-verdi-samling stil="horisontal" class="detaljer-linje">
      <!--enkeltdagsmøte - viser starttidspunkt med mindre ingen saker har satt varighet-->
      @if (!sakstidspunkt().flerdagsmoete && !sakstidspunkt().ingenVarigheterSatt) {
        <tittel-verdi tittel="{{ 'Starttidspunkt' | translate }}" [verdi]="sakstidspunkt().start | zoneddatetimeSomPlainTime | plaintime" data-testid="sakstidspunkt"/>
      }
      <!--flerdagsmoete - viser dag og starttidspunkt dersom ALLE saker har satt varighet, eller starttidpunkt er satt på pausen-->
      @if (sakstidspunkt().flerdagsmoete && (!sakstidspunkt().enkelteVarigheterIkkeSatt || sakstidspunkt().start)) {
        <tittel-verdi tittel="{{ 'Starttidspunkt' | translate }}" data-testid="sakstidspunkt">
          <verdi>
            {{ 'Dag {dag}' | translate: {dag: sakstidspunkt().dag + 1} }},
            {{ sakstidspunkt().start | zoneddatetimeSomPlaindate | plaindate:{weekday: 'short', day: 'numeric'} }}
            {{ sakstidspunkt().start | zoneddatetimeSomPlainTime | plaintime }}
          </verdi>
        </tittel-verdi>
      }
      <!--flerdagsmoete - viser kun dag når IKKE alle saker har satt varighet og det ikke er satt starttidspunkt-->
      @if (sakstidspunkt().flerdagsmoete && sakstidspunkt().enkelteVarigheterIkkeSatt && !sakstidspunkt().start) {
        <tittel-verdi tittel="{{ 'Starttidspunkt' | translate }}" [verdi]="'Dag {{dag}}' | translate: {dag: sakstidspunkt().dag + 1}" data-testid="sakstidspunkt"/>
      }
      <!--enkeltdagsmøte - viser varighet (beregnet eller angitt) med mindre ingen saker har satt varighet-->
      @if (!sakstidspunkt().flerdagsmoete && !sakstidspunkt().ingenVarigheterSatt) {
        <tittel-verdi tittel="{{ 'Varighet' | translate }}" data-testid="saksvarighet">
          <verdi>
            {{ sakstidspunkt().varighet | duration: 'timerMinutterKort' }}
            @if (sakstidspunkt().varighetBeregnet) {
              <span class="std-nedtonet">
                {{ '(beregnet)' | translate }}
                <span [matTooltip]="'Varighet er ikke satt på pausen, viser derfor beregnet varighet basert på gjenværende tid' | translate" matTooltipPosition="below"></span>
              </span>
            }
          </verdi>
        </tittel-verdi>
      }
      <!--flerdagsmoete - viser varighet dersom angitt av bruker på pausen-->
      @if (sakstidspunkt().flerdagsmoete && sakstidspunkt().varighetAngitt) {
        <tittel-verdi tittel="{{ 'Varighet' | translate }}" [verdi]="sakstidspunkt().varighet | duration: 'timerMinutterKort'" data-testid="saksvarighet"/>
      }
      @if (!sakstidspunkt().varighetAngitt && !sakstidspunkt().varighetBeregnet) {
        <tittel-verdi tittel="{{ 'Varighet ikke satt' | translate }}" data-testid="saksvarighet"/>
      }
    </tittel-verdi-samling>

    <tittel-verdi stil="vertikal--med-linje" class="pausebeskrivelse" data-testid="saksbeskrivelse">
      <tittel>
        {{ 'Pausebeskrivelse' | translate }}
        @if (redigeringMulig()) {
          <button mat-icon-button class="md-icon-button-mindre" (click)="redigerPause()" [disabled]="menyDeaktivert()">
            <mat-icon>edit</mat-icon>
          </button>
        }
      </tittel>
      <verdi>
        <html-formatert [innhold]="pause().beskrivelse"/>
      </verdi>
    </tittel-verdi>
  </div>
}
